import {
  hrService,
  IEmployeeUnderProbationListResponse,
} from "../../../../../Api/Services/HRService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const fetchEmpoyeeUnderProbationList = createServiceAsyncThunk<
  IEmployeeUnderProbationListResponse,
  { probationStatus: string }
>(
  ACTION_NAMES.FETCH_EMPLOYEE_UNDER_PROBATION_LIST,
  ({ probationStatus }: { probationStatus: string }) =>
    hrService.employeeUnderProbation(probationStatus),
  ERROR_MESSAGES.FETCH_EMPLOYEE_PROBATION_LIST_FAILURE
);

export const employeeUnderProbationSlice = createGenericSlice<
  IEmployeeUnderProbationListResponse,
  { probationStatus: string }
>(SLICE_NAMES.EMPLOYEE_PROBATION_SLICE, fetchEmpoyeeUnderProbationList);

export const {
  clearError: clearEmployeeUnderProbationError,
  clearSuccessMessage: clearEmployeeUnderProbationSuccess,
} = employeeUnderProbationSlice.actions;

export default employeeUnderProbationSlice.reducer;
